export const comments_3296180 = {"data":{"data":[],"links":{}}}